import { css } from 'styled-components';
import { colorsV2 } from '../../../../../../colors-v2';

const TABLE_BORDER_COLOR = '#c1c7d0';
const tdStyle = css`
  position: relative;
  height: 49px;
  min-width: 80px;
  vertical-align: top;
  border-style: solid;
  border-width: 0 0 1px;
  border-color: ${TABLE_BORDER_COLOR};
  border-image: initial;
  padding: 8px;

  h3 {
    color: unset;
    font-weight: unset;
    font-size: unset;
    margin: 0;
  }

  &.border {
    border-width: 1px 0 1px 1px;
    border-style: solid;
  }

  .table-resize-decoration {
    background-color: transparent;
    position: absolute;
    width: 10px;
    height: 100%;
    top: 0;
    right: -5px;
    cursor: col-resize;
    z-index: 109;

    &:after {
      content: '';
      right: 4px;
      position: absolute;
      width: 2px;
      height: calc(100% + 1px);
      background-color: transparent;
      z-index: 20;
      top: 0;
    }

    &.hovered {
      &:after {
        background-color: ${colorsV2.blue100};
      }
    }
  }

  .table-column-controls-decoration {
    cursor: pointer;
    position: absolute;
    width: calc(100% + 2px);
    left: -1px;
    top: -26px;
    height: 25px;
    box-sizing: border-box;
    display: block;
    margin-top: 0;

    &:after {
      content: '';
      background: ${colorsV2.gray10};
      border-top: 1px solid ${TABLE_BORDER_COLOR};
      border-right: 1px solid ${TABLE_BORDER_COLOR};
      border-left: 1px solid ${TABLE_BORDER_COLOR};
      border-image: initial;
      display: block;
      box-sizing: border-box;
      padding: 0;
      border-bottom: none;
      height: 11px;
      width: 100%;
      position: absolute;
      top: 14px;
      left: 0;
      z-index: 10;
    }
  }

  &.heading {
    background-color: ${colorsV2.gray10};
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
  }

  &.last-row {
    border-bottom: 1px solid ${TABLE_BORDER_COLOR};
  }

  &.hover-on-add-button {
    .table-column-controls-decoration {
      &:after {
        z-index: 0;
      }
    }
  }

  &.hover-on-delete-table {
    border-color: ${colorsV2.red100};
    border-width: 1px;
    background: ${colorsV2.red10};

    &:after {
      background: ${colorsV2.red100};
    }

    .table-column-controls-decoration {
      &:after {
        background-color: ${colorsV2.red20};
        border-color: ${colorsV2.red100};
      }
    }
  }

  &.cell-hovered,
  &.cell-selected {
    border-color: ${colorsV2.blue100};
    border-width: 1px;

    .table-column-controls-decoration {
      &:after {
        color: ${colorsV2.white100};
        background-color: ${colorsV2.blue100};
        border-color: ${colorsV2.blue100};
        z-index: 11;
      }
    }

    &:after {
      content: '';
      position: absolute;
      height: 1px;
      background: ${colorsV2.blue100};
      top: -1px;
      z-index: 1;
      left: 0;
      right: 0;
    }

    &.hover-on-delete {
      background-color: ${colorsV2.red10};
      border-color: ${colorsV2.red100};

      .table-column-controls-decoration {
        &:after {
          background-color: ${colorsV2.red20};
          border-color: ${colorsV2.red100};
        }
      }

      &:after {
        background-color: ${colorsV2.red100};
      }
    }
  }

  &.is-in-table {
    &.first-row {
      &.column-selected {
        .table-column-controls-decoration {
          &:after {
            color: ${colorsV2.white100};
            background-color: ${colorsV2.blue100};
            border-color: ${colorsV2.blue100};
            z-index: 11;
          }
        }
      }

      &:before {
        content: '';
        background-color: ${TABLE_BORDER_COLOR};
        position: absolute;
        height: 4px;
        width: 4px;
        border-radius: 50%;
        pointer-events: none;
        top: -24px;
        right: -2px;
      }
    }
  }

  .slate-align-center {
    text-align: center;
  }

  .slate-align-left {
    text-align: left;
  }

  .slate-align-right {
    text-align: right;
  }
`;

const trStyle = css`
  &:first-child {
    .table-resize-decoration {
      &:after {
        top: -12px;
        height: calc(100% + 12px);
      }
    }
  }

  &.is-read-only {
    cursor: pointer;
    &:hover {
      background-color: ${colorsV2.gray10};
    }
  }
`;

export const tableStyle = css`
  table {
    table-layout: fixed;
    border-collapse: collapse;
    margin: 24px 0 0;

    width: auto;
    border: 1px solid rgb(193, 199, 208);
    border-left-style: none;
    border-bottom-style: none;

    &.border {
      border-left-style: solid;
    }

    &.inside-blog {
      table-layout: auto;
      width: 100% !important;
    }

    table > tbody > span {
      display: none;
    }

    tr {
      ${trStyle}
    }

    td {
      ${tdStyle}
    }
  }
`;
